/* eslint-disable linebreak-style */
const getResponsiveImageUrl = (src, srcSet, isMobile) => {
  if (!srcSet) return src;
  const srcSetList = srcSet.split(',').reverse().map((e) => {
    const srcSetValue = e.trim().split(' ');
    if (srcSetValue.length > 1) {
      return {
        scr: srcSetValue[0],
        size: +srcSetValue[1].substring(0, (srcSetValue[1].length - 1))
      };
    }
    return {};
  }).sort((a, b) => b?.size - a?.size)
    .map((e) => {
      if (e.size <= 470) {
        return { device: 'phone', src: e.scr };
      }
      if (e.size >= 1024) {
        return { device: 'desktop', src: e.scr };
      }
      return {};
    });

  const srcResponsive = srcSetList.find((e) => e.device === (isMobile ? 'phone' : 'desktop'));

  return srcResponsive ? srcResponsive.src : src;
};

export default getResponsiveImageUrl;
